import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaHome, FaArrowLeft } from "react-icons/fa";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container fluid className="vh-100 d-flex align-items-center" >
      <Row className="w-100 justify-content-center text-center">
        <Col md={6}>
          
          {/* 404 Heading */}
          <h1 className="display-1 fw-semibold primary-class">404</h1>

          {/* Message */}
          <h3 className="fw-semibold mt-2">Page Not Found</h3>
          <p className="text-muted mt-3 mb-4">
            Sorry, the page you are looking for does not exist or has been moved.
          </p>

          {/* Action Buttons */}
          <div className="d-flex justify-content-center gap-3">
            <Button className="landing-primary-class" onClick={() => navigate("/")}>
              <FaHome className="me-2 " />
              Go Home
            </Button>

            <Button variant="outline-secondary" onClick={() => navigate(-1)}>
              <FaArrowLeft className="me-2" />
              Go Back
            </Button>
          </div>

        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
